module.exports = __webpack_public_path__ + "img/pause-circle.cfb38ed5.svg";